const initPopupBook = () => {
  const closeBtns = document.querySelectorAll<HTMLElement>(
    "[data-popup-book-close]"
  );
  const openBtns = document.querySelectorAll<HTMLElement>(
    "[data-popup-book-open]"
  );
  const drawerCloses = document.querySelectorAll<HTMLElement>(
    "[data-drawer-close]"
  );
  const header = document.getElementById("shopify-section-header");
  const popup = document.getElementById("popup-book");

  if (header && popup) {
    closeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        header.classList.add("header__outer-wrapper");
        popup.classList.remove("is-fixed", "is-visible", "active");
      });
    });

    openBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        header.classList.remove("header__outer-wrapper");
        popup.classList.add("is-fixed", "is-visible", "active");
        if (drawerCloses.length) {
          drawerCloses.forEach((btn) => btn.click());
        }
      });
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  initPopupBook();
});
